import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type {
	NotiFicationButton,
	NotiFicationDatum
} from '../../config/notifications'

interface MessageState extends Omit<NotiFicationDatum, 'button'> {
	button: NotiFicationButton | null
	open: boolean
}

const INITIAL_MESSAGE: MessageState = {
	button: null,
	content: '',
	open: false,
	style: 'default',
	title: ''
}

interface NotificationState {
	message: MessageState
}

const initialState: NotificationState = {
	message: INITIAL_MESSAGE
}

const slice = createSlice({
	initialState,
	name: 'notification',
	reducers: {
		resetSnack(state) {
			state.message = INITIAL_MESSAGE
		},

		showSnack(state, action: PayloadAction<NotiFicationDatum>) {
			state.message = {
				...state.message,
				...action.payload,
				button: action.payload.button ?? null,
				open: true
			}
		}
	},

	selectors: {
		message: state => state.message,
		snackOpen: state => state.message.open,
		snackStyle: state => state.message.style
	}
})

const actions = slice.actions
const selectors = slice.selectors

export { actions, selectors, slice }
